import { Component, OnInit } from '@angular/core';
import { Params, Router,ActivatedRoute } from '@angular/router';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { VerifyModel } from 'src/app/models/login/verify.model';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.css']
})
export class VerifyOtpComponent implements OnInit {
  verifyOtp: VerifyModel;
  Loader: boolean = false;
  token: string;
  showMessageLoader: boolean = true;
  formHideLoader: boolean = false;
  showFormLoader: boolean = true;


  constructor(private localstorage:LocalstorageService, private alertify:AlertifyService,private route: ActivatedRoute, private router:Router, private _loginService: LoginService) 
  {
    this.verifyOtp = new VerifyModel();
  }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.token = params['token'];
    });
  }
  onSubmit()
  {
    if (this.verifyOtp.Password == "" || this.verifyOtp.Password == null || this.verifyOtp.Password == undefined) {
      this.alertify.error("Password is required");
      return;
    }
    this.Loader = true;
    this.showMessageLoader = false;
    this.formHideLoader = false;
    this.showFormLoader = true;
    this.verifyOtp.Token = this.token;
    this._loginService.verifyOtp(this.verifyOtp).subscribe(res => {
      var responseData = JSON.parse(res._body);
        if (responseData.isSuccess)
          {
            this.Loader = false;
            this.showMessageLoader = false;
            this.formHideLoader = true;
            this.showFormLoader = false;
          }
          else 
          {
            this.alertify.error(responseData.responseMessage);
            this.Loader = false;
          }
      },
    )
  }   
}